import { defineStore } from 'pinia';
import { ref } from 'vue';

export enum ReportType {
  REGIONAL = 'regional',
  SEASONAL = 'seasonal',
}

export const useExceptionReportStore = defineStore('exception-report', () => {
  const isBusy = ref(false);
  const activeReport = ref<ReportType | null>(null);

  function startReport(type: ReportType) {
    isBusy.value = true;
    activeReport.value = type;
  }

  function finishReport() {
    isBusy.value = false;
    activeReport.value = null;
  }

  return {
    isBusy,
    activeReport,
    startReport,
    finishReport,
  };
});
